import React, { useRef, useState } from "react";
import { authFetch } from "../../utils/authFetch";

const CANTIDAD_DIGITOS = 5;

const DesinscribirMateriaModal = ({ show, email, onClose }) => {
  const [digitos, setDigitos] = useState(Array(CANTIDAD_DIGITOS).fill(""));
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const inputsRef = useRef([]);

  if (!show) return null;

  const clave = digitos.join("");

  const enfocar = (indice) => {
    inputsRef.current[indice]?.focus();
    inputsRef.current[indice]?.select();
  };

  const handleChangeDigito = (indice, valor) => {
    const soloDigito = valor.replace(/\D/g, "");

    if (soloDigito.length > 1) {
      // Pegaron varios dígitos de golpe: se reparten desde esta casilla.
      const nuevos = [...digitos];
      soloDigito
        .slice(0, CANTIDAD_DIGITOS - indice)
        .split("")
        .forEach((d, i) => {
          nuevos[indice + i] = d;
        });
      setDigitos(nuevos);
      enfocar(Math.min(indice + soloDigito.length, CANTIDAD_DIGITOS - 1));
      return;
    }

    const nuevos = [...digitos];
    nuevos[indice] = soloDigito;
    setDigitos(nuevos);

    if (soloDigito && indice < CANTIDAD_DIGITOS - 1) {
      enfocar(indice + 1);
    }
  };

  const handleKeyDown = (indice, e) => {
    if (e.key === "Backspace" && !digitos[indice] && indice > 0) {
      enfocar(indice - 1);
    }
  };

  const handleConfirmar = async () => {
    if (clave.length !== CANTIDAD_DIGITOS) return;

    setEnviando(true);
    setResultado(null);

    try {
      const respuesta = await authFetch("https://api.micrositec.com/api/desinscribir", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, token: clave }),
      });
      const data = await respuesta.json();

      if (respuesta.ok && data.ok) {
        setResultado({
          tipo: "exito",
          mensaje: "Ingresa y elige una nueva actividad",
        });
      } else {
        setResultado({ tipo: "error", mensaje: data.message || "No se pudo cambiar la actividad" });
      }
    } catch (error) {
      console.error("Error al elimar actividad:", error);
      setResultado({ tipo: "error", mensaje: "Error de red al procesar la solicitud." });
    }

    setEnviando(false);
  };

  const handleCerrar = () => {
    setDigitos(Array(CANTIDAD_DIGITOS).fill(""));
    setResultado(null);
    onClose();
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              {resultado?.tipo === "exito" ? "Actividad eliminada" : "Cambiar actividad"}
            </h5>
          </div>
          <div className="modal-body">
            {resultado ? (
              <p className={resultado.tipo === "exito" ? "text-success" : "text-danger"}>
                {resultado.mensaje}
              </p>
            ) : (
              <>
                <p className="mb-1">Ingresa el código de cambio proporcionado por LiFE</p>

                <div className="alert alert-info py-2 px-3 mb-3 text-start" style={{ fontSize: "0.9rem" }}>
                   Solicita una clave por correo electrónico a {" "}
                  <a href="mailto:admin@tec.com?subject=Token">aportill@tec.mx</a> o <a href="mailto:admin@tec.com?subject=Token">aatorres@tec.mx</a>
                 {" "} con el asunto Token Actividad LiFE y en el mensaje el motivo de cambio de actividad
                </div>

                <p className="text-muted mb-2" style={{ fontSize: "0.8rem" }}>
                  <strong>Recuerda, el cambio no asegura el cupo en otra actividad</strong>
                </p>

                <div className="d-flex justify-content-center gap-2">
                  {digitos.map((digito, indice) => (
                    <input
                      // eslint-disable-next-line react/no-array-index-key
                      key={indice}
                      ref={(el) => (inputsRef.current[indice] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength={CANTIDAD_DIGITOS}
                      className="form-control text-center fs-4"
                      style={{ width: "3rem" }}
                      value={digito}
                      onChange={(e) => handleChangeDigito(indice, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(indice, e)}
                      disabled={enviando}
                      autoFocus={indice === 0}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="modal-footer justify-content-center">
            {resultado ? (
              <button className="btn btn-secondary" onClick={handleCerrar}>
                {resultado.tipo === "exito" ? "Aceptar" : "Cerrar"}
              </button>
            ) : (
              <>
                <button className="btn btn-secondary" onClick={handleCerrar} disabled={enviando}>
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleConfirmar}
                  disabled={enviando || clave.length !== CANTIDAD_DIGITOS}
                >
                  {enviando ? "Validando..." : "Confirmar"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesinscribirMateriaModal;
